<template>
  <div>
    <div>
      <dia></dia>
    </div>
    <div class="row">
      <div class="col-md-12">
        <h4>Información por fechas</h4>
        <p>Administra la información contable de avanza según un rango de fechas</p>
        <br>
      </div>
      <div class="col-md-3">
        <label for="fechaInicial">Fecha inicial: </label>
        <input type="date" class="form-control" v-model="fechaInicial" style="background-color: white; border: none; border-radius: 10px;">
      </div>
      <div class="col-md-3">
        <label for="fechaInicial">Fecha inicial: </label>
        <input type="date" class="form-control" v-model="fechaFinal" style="background-color: white; border: none; border-radius: 10px;">
      </div>
      <div class="col-md-3">
        <br>
        <button class="btn btn-success btn-fill" @click="actualizarInformacion()" style="border-radius: 8px;">Buscar información</button>
      </div>
    </div>
    <div class="row">
      <br>
      <div class="col-md-12">
        <informacionfecha ref="componenteInformacionFechas"></informacionfecha>
      </div>
      <div class="col-md-6">
        <nomina ref="componenteNomina"></nomina>
        <informacionEntidad ref="componenteEntidades"></informacionEntidad>
        <informacionTerapeutas ref="componenteTerapeutas"></informacionTerapeutas>
      </div>
      <div class="col-md-6">
        <gastos ref="componenteGastos"></gastos>
        <informacionEspecialidad ref="componenteEspecialidades"></informacionEspecialidad>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        
      </div>
      <div class="col-md-6">
        
      </div>
    </div>
  </div>
</template>
<script>
import dia from "src/components/aDashboard/nomina/informacionDia.vue"
import nomina from "src/components/aDashboard/nomina/informacionGastoNomina.vue"
import gastos from "src/components/aDashboard/nomina/informacionGastos.vue"
import informacionfecha from "src/components/aDashboard/nomina/informacionFechas.vue";
import informacionEntidad from "src/components/aDashboard/nomina/informacionEntidad.vue";
import informacionEspecialidad from "src/components/aDashboard/nomina/informacionEspecialidad.vue";
import informacionTerapeutas from "src/components/aDashboard/nomina/informacionGastoTerapeutas.vue";
export default {
  components: {
    dia,
    nomina,
    gastos,
    informacionfecha,
    informacionEntidad,
    informacionEspecialidad,
    informacionTerapeutas
  },
  data() {
    return {
      fechaInicial: '',
      fechaFinal: ''
    }
  },
  methods:{
    actualizarInformacion(){
      this.$refs.componenteNomina.getNomina();
      this.$refs.componenteGastos.getGastos(this.fechaInicial, this.fechaFinal);
      this.$refs.componenteInformacionFechas.getInformationFechas(this.fechaInicial, this.fechaFinal);
      this.$refs.componenteEntidades.getInformationEntidades(this.fechaInicial, this.fechaFinal);
      this.$refs.componenteEspecialidades.getInformationEspecialidades(this.fechaInicial, this.fechaFinal);
      this.$refs.componenteTerapeutas.getNominaTerapeutas(this.fechaInicial, this.fechaFinal);
    }
  }
};
</script> 


// WEBPACK FOOTER //
// src/components/ADashboard/dashboardNomina.vue